import { render, staticRenderFns } from "./FilteredProducts.vue?vue&type=template&id=2b5d1a11&"
import script from "./FilteredProducts.vue?vue&type=script&lang=js&"
export * from "./FilteredProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports